app.service('accountWarrantiesManager', function (front, pageConfig, modal, upsellingWarranties, orderSubscriptionWarranties) {
	let $body, $warrantiesOrderPreview, $warrantiesOrderList;

	function init() {
		setElements();

		if(!pageConfig.getData('account').guestLogged){
			upsellingWarranties.init();
			orderSubscriptionWarranties.init();

			if (front.page() === "order-preview") {
				$body.addClass('account-warranties-loading');
				upsellingWarranties.loadAvailableWarrantiesForPreview()
					.then(response => $warrantiesOrderPreview.html(response))
					.always(() => $body.removeClass('account-warranties-loading'));
			}

			if (front.page() === "account-main-page" || front.page() === "order-list-active") {
				if (!pageConfig.getData('account').isUserLogged) {
					return;
				}

				$body.addClass('account-warranties-loading');
				$.when(upsellingWarranties.loadUpsellingWarranties(), orderSubscriptionWarranties.loadOrderSubscriptionWarranties())
					.done(renderWarrantyList)
					.always(() => $body.removeClass('account-warranties-loading'));
			}
		}
	}

	function setElements() {
		$body = $('body');
		$warrantiesOrderPreview = $('#order-preview-warranties', $body);
		$warrantiesOrderList = $('#order-list-warranties', $body);
	}

	function renderWarrantyList(upsellingWarrantiesResponse, orderSubscriptionWarrantiesResponse) {

		const [upsellingWarrantiesHtml, textStatus1] = upsellingWarrantiesResponse;
		const [orderSubscriptionWarrantiesHtml, textStatus2] = orderSubscriptionWarrantiesResponse;

		if (textStatus1 === "success") {
			$warrantiesOrderList.append(upsellingWarrantiesHtml);
		}
		if (textStatus2 === "success") {
			$warrantiesOrderList.prepend(orderSubscriptionWarrantiesHtml);
		}
	}

	return {
		init
	};
});